import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { AdminPage } from "./pages/AdminPage";
import { AlertsPage } from "./pages/AlertsPage";
import { BottlenecksPage } from "./pages/BottlenecksPage";
import { ComparisonsPage } from "./pages/ComparisonsPage";
import { CrossListsPage } from "./pages/CrossListsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ImportsPage } from "./pages/ImportsPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { RoomsPage } from "./pages/RoomsPage";
import { ScheduleBuilderPage } from "./pages/ScheduleBuilderPage";
import { ScenariosPage } from "./pages/ScenariosPage";
import { SectionsPage } from "./pages/SectionsPage";
import { TimetablePage } from "./pages/TimetablePage";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "timetable", element: <TimetablePage /> },
      { path: "schedule-builder", element: <ScheduleBuilderPage /> },
      { path: "rooms", element: <RoomsPage /> },
      { path: "cross-lists", element: <CrossListsPage /> },
      { path: "bottlenecks", element: <BottlenecksPage /> },
      { path: "sections", element: <SectionsPage /> },
      { path: "imports", element: <ImportsPage /> },
      { path: "comparisons", element: <ComparisonsPage /> },
      { path: "scenarios", element: <ScenariosPage /> },
      { path: "alerts", element: <AlertsPage /> },
      { path: "admin", element: <AdminPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
